import UIComponent from "../ui/component";
import api from "../api";

export class TranscriptionsList extends UIComponent {
    selectedItems = {};

    init() {
        if (!this.items || !Array.isArray(this.items)) {
            console.warn("Items не инициализированы или не массив");
            return;
        }

        this.selectAllCheckbox.on( "change",this.onSelectAllCheckboxChange.bind(this));
        this.items.forEach((item) => {item.on("checkboxChange", this.onCheckboxChange.bind(this));});

        this.selectedItems = {};
        this.updateStatuses();
    }

    onCheckboxChange(event) {
        const { isChecked, id } = event.detail.detail;

        if (isChecked) {
            this.selectedItems[id] = true;
        } else {
            delete this.selectedItems[id];
        }
        this.emit("selectionChange", Object.keys(this.selectedItems));
    }

    onSelectAllCheckboxChange(e) {
        const checked = e.target.checked;
        this.items.forEach((item) => {
            if (!item.checkbox.disabled) {
                item.setChecked(checked);

                const id = item.getId();
                if (checked) {
                    this.selectedItems[id] = true;
                } else {
                    delete this.selectedItems[id];
                }
            }
        });

        this.emit("selectionChange", Object.keys(this.selectedItems));
    }

    getTranscriptionsIds() {
        return this.items.map((transcription) => transcription.getId());
    }

    getTranscriptionById(id) {
        const idStr = String(id);
        return this.items.find((transcription) => {
            const tId =
                transcription.id ||
                (transcription.getId && transcription.getId());
            return tId && String(tId) === idStr;
        });
    }

    async updateStatuses() {
        let allCompleted = true;

        try {
            const ids = this.getTranscriptionsIds();
            if (ids.length === 0) {
                return;
            }

            const response = await api.post("/api/files/status", { id: ids });

            response.forEach((item) => {
                const transcription = this.getTranscriptionById(item.id);
                if (transcription) {
                    transcription.updateRow(item);
                    if (!transcription.isCompleted()) {
                        allCompleted = false;
                    }

                    if (
                        !transcription.isCompleted() &&
                        transcription.isChecked()
                    ) {
                        transcription.setChecked(false);
                        delete this.selectedItems[item.id];
                    }
                }
            });
        } catch (error) {
            console.error("Ошибка при обновлении статусов:", error);
        }

        if (!allCompleted) {
            setTimeout(() => this.updateStatuses(), 3000);
        }
    }
}
